import {Injectable} from "@angular/core";

@Injectable()
export class BookingService {
    private booking_id: string;
    private booking_id_version: string;
    private watabi_hash: string;

    constructor() {
        this.booking_id = sessionStorage.getItem('_watabilightBookingId');
        this.booking_id_version = sessionStorage.getItem('_watabilightBookingIdVersion');
        this.watabi_hash = sessionStorage.getItem('_watabilightHash');
    }

    public setBookingId(id: string): void {
        sessionStorage.setItem('_watabilightBookingId', id);
        this.booking_id = id;
    }

    public getBookingId(): string {
        return this.booking_id;
    }

    public setBookingIdVersion(id: string): void {
        sessionStorage.setItem('_watabilightBookingIdVersion', id);
        this.booking_id_version = id;
    }

    public getBookingIdVersion(): string {
        return this.booking_id_version;
    }

    public setWatabihash(id: string): void {
        sessionStorage.setItem('_watabilightHash', id);
        this.watabi_hash = id;
    }

    public getWabatiHash(): string {
        return this.watabi_hash;
    }

}